export default __webpack_public_path__ + "static/media/bg.91ada0af.jpg";